import _ from 'lodash';
import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        managers: [],
        total: 0,
    },
    getters: {
    },
    actions: {
        async fetch({ state }, { page }) {
            const limit = 10;
            const params = {
                offset: (page - 1) * limit,
                limit,
            };
            const result = await Sdk.ManagerAccess.PrivateList({ params });
            state.managers = _.map(result.data.raw, (managerAccess) => ({
                accessId: managerAccess.id,
                authId: managerAccess.auth.id,
                managerId: managerAccess.manager.id,
                account: managerAccess.auth.account,
                name: managerAccess.manager.name,
            }));
            state.total = result.data.total;
        },
        create(__, data) {
            return Sdk.Manager.Create(data).then((response) => {
                const { auth, user } = response.data;
                return Sdk.ManagerAccess.PrivateCreateResource({ auth, manager: user });
            });
        },
        update(__, data) {
            const { managerId } = data;
            const payload = _.pick(data, ['name']);
            return Sdk.ManagerInfoResource.PrivateUpdateResource(managerId, payload);
        },
        delete(__, data) {
            return Sdk.ManagerAuthResource.PrivateDeleteResource(data.authId);
        },
        resetPassword(__, { data, payload }) {
            return Sdk.Manager.UpdatePassword({ ...data, user: payload.managerId });
        },
    },
};
